import React from "react"
import { useAlgoliaSearchState } from "../../controller/state"

import CheckboxFilterTag from "../CheckboxFilterTag"
import { FacetOption } from "../types"

export const BrandTagItems = () => {
  const { uiFilters, updateSearchParams } = useAlgoliaSearchState()
  if (!uiFilters) {
    return <></>
  }

  const handleRemove = (option: FacetOption) => {
    updateSearchParams((state) => {
      return {
        ...state,
        brandNames: state.brandNames?.filter((x) => x !== option.value),
      }
    })
  }

  return (
    <>
      {uiFilters.brands
        .filter((x) => x.selected && !x.disabled)
        .map((x, index) => (
          <div key={index} className="mb-2 mr-2">
            <CheckboxFilterTag
              label={x.label}
              onRemove={() => handleRemove(x)}
            />
          </div>
        ))}
    </>
  )
}
